import classNames from 'classnames'
import { ReactNode } from 'react'

interface IProps {
  classes?: string
  children: ReactNode
}

export const StatusWidgetContainer = ({ classes, children }: IProps) => (
  <div className={classNames('flex items-center justify-center', classes)}>{children}</div>
)
